import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import instagramIcon from '../../assets/images/common/common_footer_instagram.svg';
import kakaoIcon from '../../assets/images/common/common_footer_kakao.svg';

function Footer() {
  const location = useLocation();
  
  const handleAboutClick = (e: React.MouseEvent) => {
    if (location.pathname === '/about') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // 다른 페이지에서 이동하는 경우, 페이지 이동 후 스크롤
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }
  };

  const handlePartnerClick = (e: React.MouseEvent) => {
    if (location.pathname === '/partner') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // 다른 페이지에서 이동하는 경우, 페이지 이동 후 스크롤
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }
  };

  const handleBrandClick = (e: React.MouseEvent) => {
    if (location.pathname === '/brand') {
      e.preventDefault();
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      // 다른 페이지에서 이동하는 경우, 페이지 이동 후 스크롤
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    }
  };
  return (
    <footer className="bg-white border-t border-gray-200 pt-8 pb-8">
      <div className="w-full mx-auto px-6 md:px-8">
        <div className="flex flex-col md:flex-row justify-between items-start md:items-start">
          {/* 왼쪽 영역 - 회사 정보 */}
          <div className="w-full md:w-1/2 flex flex-col justify-center items-left md:items-center order-2 md:order-1">
            <div className="flex flex-col justify-center items-start md:items-center">
              <div className="text-sm text-black leading-relaxed text-left md:text-left mt-[50px] md:mt-[60px] mb-[20px] md:mb-[60px]">
                <div className="text-[15px] md:text-[20px] leading-[160%] text-[#000000] font-bold mb-[20px]">(주)챙기고</div>
                <div className="text-[15px] md:text-[18px] leading-[160%] text-[#000000] font-normal mb-[8px]">대표 : 박태홍</div>
                <div className="text-[15px] md:text-[18px] leading-[160%] text-[#000000] font-normal mb-[8px]">사업자등록번호 : 197-87-02701</div>
                <div className="text-[15px] md:text-[18px] leading-[160%] text-[#000000] font-normal mb-[8px]">통신판매업 신고번호 : 제 2022-서울강남-05228 호</div>
                <div className="text-[15px] md:text-[18px] leading-[160%] text-[#000000] font-normal mb-[8px]">주소 : 서울특별시 강남구 테헤란로 6길 33, 2층</div>
                <div className="text-[15px] md:text-[18px] leading-[160%] text-[#000000] font-normal mb-[8px]">고객 문의 : <a href="mailto:cs@ponpish.kr" className="underline">cs@ponpish.kr</a></div>
                <div className="text-[15px] md:text-[18px] leading-[160%] text-[#000000] font-normal mb-[8px]">파트너 안경원 문의 : <a href="mailto:partners@ponpish.kr" className="underline">partners@ponpish.kr</a></div>
                <div className="text-[15px] md:text-[18px] leading-[160%] text-[#000000] font-normal mb-[8px]">마케팅/제휴 문의 : <a href="mailto:brand@ponpish.kr" className="underline">brand@ponpish.kr</a></div>
              </div>
            </div>
          </div>
          {/* 오른쪽 영역 - 소개/문의/방침, SNS */}
          <div className="w-full md:w-1/2 flex flex-col justify-center items-left md:items-center order-2 md:order-1">
            <div className="flex flex-col justify-center items-start md:items-start">
              <div className="hidden md:flex flex-col gap-2 items-start md:items-left md:mt-[70px] mb-[40px] md:mb-[64px]">
                <a href="https://ponpish.co.kr/" target="_blank" rel="noopener" className="text-[18px] font-bold md:text-[18px] leading-[160%] text-[#973BEE] underline">폰피쉬 쇼핑몰</a>
                <Link to="/about" onClick={handleAboutClick} className="text-[18px] font-normal md:text-[18px] leading-[160%] text-[#000000] underline">폰피쉬 소개</Link>
                <Link to="/partner" onClick={handlePartnerClick} className="text-[18px] font-normal md:text-[18px] leading-[160%] text-[#000000] underline">파트너 안경원</Link>
                <Link to="/brand" onClick={handleBrandClick} className="text-[18px] font-normal md:text-[18px] leading-[160%] text-[#000000] underline">제휴</Link>
                <a href="https://ponpish.notion.site/PONPISH-1fbd3c74a7588002a48cfe1a24166254?source=copy_link" target="_blank" rel="noopener noreferrer" className="text-[18px] font-normal md:text-[18px] leading-[160%] text-[#000000] underline">개인정보 처리방침</a>
              </div>
              <div className="flex flex-col gap-2 mt-8 items-start md:items-center ml-[4px] md:ml-0">
                <div className="text-[16px] md:text-[20px] leading-[160%] text-[#000000] font-bold mb-2 md:text-center">Follow US</div>
                <div className="flex gap-3">
                  <a href="https://www.instagram.com/ponpish_kr/" target="_blank" rel="noopener noreferrer">
                    <img src={instagramIcon} alt="Instagram" className="w-[32px] md:w-[40px] h-[32px] md:h-[40px]" />
                  </a>
                  <a href="https://pf.kakao.com/_Hycxin/chat" target="_blank" rel="noopener noreferrer">
                    <img src={kakaoIcon} alt="Kakao" className="w-[32px] md:w-[40px] h-[32px] md:h-[40px]" />
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="text-left mt-[40px] md:mt-[0px] text-[15px] md:text-[16px] text-gray-500 mb-[4px] md:text-center">Copyright © ponpish. All rights reserved.</div>
      </div>
    </footer>
  );
}

export default Footer; 